import script from "./TicketMovingDiv.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketMovingDiv.vue?vue&type=script&setup=true&lang=js"

import "./TicketMovingDiv.vue?vue&type=style&index=0&id=97e95b22&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97e95b22"]])

export default __exports__